__turbopack_context__.v({
  "modal": "biometric-id-modal-module-scss-module__GE_69G__modal",
  "modal__content": "biometric-id-modal-module-scss-module__GE_69G__modal__content",
  "modal__content-wrapper": "biometric-id-modal-module-scss-module__GE_69G__modal__content-wrapper",
  "modal__footer": "biometric-id-modal-module-scss-module__GE_69G__modal__footer",
  "modal__header": "biometric-id-modal-module-scss-module__GE_69G__modal__header",
  "modal__icon": "biometric-id-modal-module-scss-module__GE_69G__modal__icon",
});
